import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://xwbgswtixpeifiladzhs.supabase.co';
const supabaseAnonKey = 'sb_publishable_VhrDa8TFdnqhxaN52l6bFA_2u8y2XQB';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
